import { CloudForwarderForwarderInputProfiles } from "@graylog/enterprise-api";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
export const KEY_PREFIX = ["forwarder-inputs", "overview"];
export const keyFn = (searchParams) => [...KEY_PREFIX, searchParams];
export const fetchForwarderInputsList = (searchParams) => {
  var _a, _b;
  return CloudForwarderForwarderInputProfiles.listInputsOverview(
    searchParams.page,
    searchParams.pageSize,
    searchParams.query,
    FiltersForQueryParams(searchParams.filters),
    (_a = searchParams.sort) == null ? void 0 : _a.attributeId,
    (_b = searchParams.sort) == null ? void 0 : _b.direction
  ).then((response) => ({
    list: response.elements.map((input) => {
      var _a2;
      return {
        ...input,
        input_id: input.id,
        input_state: input.input_state,
        id: `${input.id}-${(_a2 = input.forwarder_id) != null ? _a2 : ""}`
      };
    }),
    attributes: response.attributes,
    pagination: { total: response.total }
  }));
};
